/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import Image from "next/image";
import React from "react";

const JobHighlightsCard = ({ jobDetails, handleSeeMoreWalkInDetailsClick }) => {
	const jobHighlights = jobDetails?.job_highlights || [];

	const renderHighlightSubHeading = (highlight) => {
		if (highlight?.tracking_constant === "walk_in_interview_details") {
			const seeMoreIndex = highlight?.description?.indexOf("See details below");
			const walkInDescription = highlight?.description?.substring(0, seeMoreIndex);
			return (
				<>
					{walkInDescription || highlight?.description}
					<span
						className="cursor-pointer font-semibold text-[#1F8268]"
						onClick={handleSeeMoreWalkInDetailsClick}
					>
						See details
					</span>
				</>
			);
		}
		return highlight?.description;
	};

	return (
		<div className="rounded-lg border border-solid border-[#C1DBFB] bg-[#F5F9FE] p-[12px] md:p-[16px]">
			<p className="mb-[16px] text-md font-semibold">Job highlights</p>
			<div className="space-y-[8px] md:grid md:grid-cols-2 md:gap-[12px] md:space-y-0">
				{jobHighlights.map((highlight) => (
					<div className="flex gap-[8px]">
						<div className="h-[24px] w-[24px] md:mt-[1px]">
							<Image src={highlight?.icon_link} height={24} width={24} />
						</div>
						{highlight?.tracking_constant === "walk_in_interview_details" ? (
							<div className="flex flex-1 flex-col">
								<p className="m-0 text-sm">{highlight?.heading}</p>
								{highlight?.description && (
									<p className="m-0 text-[14px] leading-[16px] text-[#8C8594] md:leading-[20px]">
										{renderHighlightSubHeading(highlight)}
									</p>
								)}
							</div>
						) : (
							<div className="flex flex-1 flex-col">
								<p className="m-0 text-sm">{highlight?.heading}</p>
								{highlight?.descriptions?.map((h) => (
									<p className="m-0 text-[14px] leading-[16px] text-[#8C8594] md:leading-[20px]">
										{h}
									</p>
								))}
							</div>
						)}
					</div>
				))}
			</div>
		</div>
	);
};

export default JobHighlightsCard;
